import { tracking, ARROW_LEFT_CODE, ARROW_RIGHT_CODE, ENTER_CODE } from "@bark/bark-core";

export const verifyPhoneNumberChange = (telephone, onVerifySuccess, onInvalidPhone) => {
    sendVerifySmsToPhoneNumber(telephone, onVerifySuccess, onInvalidPhone);
};

export const verifyPhoneNumberIsMobile = (telephone, actionIfMobile, actionIfLandline) => {
    triggerPhoneCheck(telephone)
        .then(data => {
            if (data.isMobile) {
                actionIfMobile && actionIfMobile();
            } else {
                actionIfLandline && actionIfLandline();
            }
        }).catch(() => {
            actionIfMobile && actionIfMobile();
        });
};

const sendVerifySmsToPhoneNumber = function (phoneNumber, onVerifySuccess, onInvalidPhone) {
    let showSmsModal = true;
    const modalIdentifier = getModalIdentifier();

    triggerContactVerification(phoneNumber)
        .then(data => {
            if (!data.status) {
                //submit form no contact verification or phone change
                return;
            }
            const verificationCodeIdentifier = getVerificationCodeIdentifier();
            $(`${modalIdentifier} .sms-verification-continue`).text('Confirm');
            smsVerificationShow('sms-form');
            $(modalIdentifier).modal('show');
            $(`${modalIdentifier} .sms-errors`).text('').toggleClass('d-none', true);
            if (window.Bark.isMobile()) {
                $(`${modalIdentifier} .sms-verification-form .code-input`).addClass('d-none');
                $(`${modalIdentifier}  ${verificationCodeIdentifier}`).removeClass('d-none').focus();
            } else {
                $(`${modalIdentifier}  ${verificationCodeIdentifier}-0`).focus();
            }
            for (let i = 0; i < 4; i++) {
                $(getVerificationCodeIdentifier() + '-' + i).val('');
            }
            $(`${modalIdentifier} ${verificationCodeIdentifier}`).val('');
            $(`${modalIdentifier} .number-to-verify`).text(data.last_four_digits);
            bindModalEvents(onVerifySuccess);
        })
        .catch(() => {
            onInvalidPhone && onInvalidPhone();
            showSmsModal = false;
        })
        .finally(() => {

            if (showSmsModal) {
                $(modalIdentifier).modal('show');

                tracking(
                    "Feature",
                    "change phone sms verification",
                    {
                    }
                );
            }
        });
}

/**
 * Trigger contact verification
 * @param {string} telephone
 * @returns {Promise}
 */
const triggerPhoneCheck = telephone => {
    var locale = (window.Bark.ENV.locale || "").toLowerCase();

    return new Promise((resolve, reject) => {
        const payload = {
            phone: telephone,
            locale : locale
        };

        Bark.api(
            '/contact-verification/is-mobile',
            payload,
            function(data) {
                if (data.status) {
                    resolve(data);
                } else {
                    reject(data);
                }
            },
            function(error) {
                reject(error);
            },
            'POST',
            Bark.apiVersionHeader('v2')
        );
    });
}

/**
 * Trigger contact verification
 * @param {string} telephone
 * @returns {Promise}
 */
const triggerContactVerification = telephone => {
    return new Promise((resolve, reject) => {
        const payload = {
            tel: telephone,
            contactMethodType: 'phone'
        };

        Bark.api(
            '/buyer/trigger-phone-verification',
            payload,
            function(data) {
                if (data.status) {
                    resolve(data);
                } else {
                    reject(data);
                }
            },
            function(error) {
                reject(error);
            },
            'POST',
            Bark.apiVersionHeader('v2')
        );
    });
}

/**
 *
 * @param {string} code
 * @param {string} phone
 * @param {function} successCallback
 * @param {function} failCallback
 */
const submitContactVerification = (code, phone, successCallback = null, failCallback = null) => {
    const payload = {
        identifierType: 'uid',
        scope: 'buyer',
        code: code,
        tel: phone,
        contactMethodType: 'phone'
    };

    Bark.api(
        'buyer/verify-phone/',
        payload,
        function(data) {
            if (data.status) {
                tracking(
                    "Feature",
                    "change_phone - Sms Verification - Success",
                    {
                    }
                );
                successCallback && successCallback(data);
            } else {
                tracking(
                    "Feature",
                    "change_phone - Sms Verification - Fail",
                    {
                    }
                );
                failCallback && failCallback(data);
            }
        },
        function(error) {

            tracking(
                "Feature",
                "change_phone - Sms Verification - Fail",
                {
                }
            );
            failCallback && failCallback(error);
        },
        'POST',
        Bark.apiVersionHeader('v2')
    );
}

const smsPostVerificationFailureCallback = (data) => {
    smsVerificationShow('sms-form');
    let errorText = _t('buyer_account-settings:error.incorrect-code');
    $('.sms-errors').text(errorText).removeClass('d-none');
}

const smsVerificationShow = showPart => {
    const elem = $(getModalIdentifier() +' .inline-bark-sms-phone-verification')
        .removeClass('sms-form')
        .removeClass('verify')
        .removeClass('sending')
        .removeClass('sent');

    if (showPart) {
        elem.addClass(showPart);
    }
}

export const showConfirmation = () => {
    $('.sms-errors').text('').addClass('d-none');
    smsVerificationShow('sent');
    $(getModalIdentifier()).modal('show');
    setTimeout(
        () => {
            $(getModalIdentifier()).modal('hide')
        },
        3000
    );
}
const smsPostVerificationCallback = (data, successCallBack) => {

    if (data.status && !data.error) {
        smsVerificationShow('sent');
        $('.sms-errors').text('').addClass('d-none');
        successCallBack && successCallBack();
        showConfirmation();
    } else {
        let errorText = _t('buyer_account-settings:error.incorrect-code');
        smsVerificationShow('sms-form');
        $('.sms-errors').text(errorText).removeClass('d-none');
    }
}

/**
 *
 * @param successCallback
 * @param failureCallback
 * @returns {boolean}
 */
const smsVerificationSubmit = (successCallback, failureCallback) => {
    const errorsElem = $('.sms-errors');
    const codeElem = $(getVerificationCodeIdentifier());
    const validCode = codeElem.val().match(/[0-9]{4}/);
    let code;

    errorsElem.toggleClass('d-none', true);

    if (validCode == null) {
        errorsElem.text(_t('buyer_account-settings:error.empty')).removeClass('d-none');
        tracking(
            "Feature",
            "change phone - Verification - Fail",
            {
            }
        );
        return false;
    }

    code = codeElem.val();
    const mobile = $('#profile_tel').val();
    smsVerificationShow('verify');

    submitContactVerification(code, mobile, successCallback, failureCallback);
}

const getModalIdentifier = () => {
    return '#change-phone-verification-modal';
}

const getVerificationCodeIdentifier = () => {
    return '#btp-verification-code';
}

const endSubmit = ($submitElement) => {
    $submitElement.removeClass('submit-waiting');
    $submitElement.removeClass('disabled');
}

/**
 */
const bindModalEvents = (onVerifySuccess) => {
    const verificationElem = $(getVerificationCodeIdentifier());
    const modalIdentifier = getModalIdentifier();

    verificationElem.on(
        "input keydown keyup mousedown mouseup contextmenu drop",
        function() {
            let input = $(this).val().replace( /\D+/g, '').substring(0, 4);
            $(this).val(input);
        }
    );

    verificationElem.on('keyup', function(e) {
        if (e.keyCode === ENTER_CODE) {
            $(modalIdentifier +' .sms-verification-continue').click();
        }
    });

    verificationElem.on('change', function() {
        let code = $(this).val().split('');

        for (let i = 0; i < code.length; i++) {
            let codeElem = $(getVerificationCodeIdentifier() + '-' + i);
            if (codeElem.val() !== code[i]) {
                codeElem.val(code[i]);
            }
        }

        if (code[3] !== 'undefined') {
            $(modalIdentifier +' .sms-verification-continue').click();
        }

        if (window.Bark.isMobile()) {
            $('.sms-verification-continue').removeClass('disabled');
        }
    });

    $(modalIdentifier + ' .sms-verification-form .code-input').on(
        "keydown contextmenu drop",
        function(e) {
            let input = $(this);
            let inputIndex = $(this).data('index');

            if (!e.key) {
                return;
            }

            function updateCode() {
                let codeArray = verificationElem.val().split('');
                for (let i = 0; i < 4; i++) {
                    codeArray[i] = $(getVerificationCodeIdentifier() + '-' + i).val();
                    if (codeArray[i] === '') {
                        codeArray[i] = ' ';
                    }
                }
                verificationElem.val(codeArray.join(''));
            }

            function prevInput(inputIndex) {
                let firstInputIndex = 0;
                if (inputIndex !== firstInputIndex) {
                    setTimeout(function() {
                        input.prev().focus();
                        input.prev().select();
                    }, 0);
                }
            }

            function nextInput(inputIndex) {
                let lastInputIndex = 3;
                if (inputIndex !== lastInputIndex) {
                    setTimeout(function() {
                        input.next().focus();
                        input.next().select();
                    }, 0);
                } else {
                    $(modalIdentifier +' .sms-verification-continue').removeClass('disabled');
                    setTimeout(
                        () => {
                            $(modalIdentifier +' .sms-verification-continue').click()
                        },
                        500
                    );
                }
            }

            if (e.keyCode === ARROW_LEFT_CODE) {
                return prevInput(inputIndex);
            }
            if (e.keyCode === ARROW_RIGHT_CODE) {
                return nextInput(inputIndex);
            }

            if (e.keyCode === ENTER_CODE) {
                $(modalIdentifier + ' .sms-verification-continue').removeClass('disabled');
                setTimeout(
                    () => {
                        $(modalIdentifier +' .sms-verification-continue').click()
                    },
                    500
                );

                return;
            }

            let inputKey = e.key;
            if (isNaN(Number(inputKey)) || e.key === null || e.key === ' ') {
                inputKey = '';
            }

            if (e.key === '') {
                return;
            }

            $(this).val(inputKey);
            updateCode();
            if(inputKey && inputKey.length > 0) {
                nextInput(inputIndex);
            }
        }
    );

    $(modalIdentifier + ' .sms-verification-continue').off('click.verificationContinue').on('click.verificationContinue', function() {
        smsVerificationSubmit(
            function(data) { smsPostVerificationCallback(data, onVerifySuccess); },
            function(data) { smsPostVerificationFailureCallback(data); }
        );
    });

    $(modalIdentifier + ' .sms-verification-btn-back').off('click.verificationBack').on('click.verificationBack', function() {
        $(getModalIdentifier()).modal('hide');
        endSubmit($('#form-manager-save'));
        tracking(
            "Feature",
            "change phone - Modal back",
            {}
        );
    });

    $(modalIdentifier + ' .sms-verification-btn-change-phone').off('click.verificationChange').on('click.verificationChange', function() {
        $(getModalIdentifier()).modal('hide');
        endSubmit($('#form-manager-save'));
        $('#profile_tel').focus();
        tracking(
            "Feature",
            "change phone - Modal Change phone",
            {}
        );
    });

    $('.js-resend-code').off('click').on('click', function() {
        $('.sms-errors').text('').addClass('d-none');
        smsVerificationShow('sending');

        triggerContactVerification($('#profile_tel').val())
            .then(() => {
                smsVerificationShow('sms-form');
            })
            .catch(() => {
                smsVerificationShow('sms-form');
            });
    });

};

